<template>
  <div class="copyright-index">
      <xi-top></xi-top>
      <div class="sub-nav-wrapper">
          <div class="item active">
              <i class="icon icon-32 icon-flow-01"></i>
              <span class="">注册账户</span>
          </div>
          <span>————————</span>
          <div class="item active">
              <i class="icon icon-32 icon-flow-02"></i>
              <span>填写资料</span>
          </div>
          <span>————————</span>
          <div class="item active">
              <i class="icon icon-32 icon-flow-03"></i>
              <span>等待审核</span>
          </div>
      </div>
      <div class="content">
          <img :src="`${IMG_HOST}pass_audit_logo.png`">
          <span>资料正在审核中，请耐心等待</span>
          <span>您可移驾到<a style="color: #fc5832;" href="http://www.ximalaya.com" target="_blank">喜马拉雅FM</a>去放松一下</span>
      </div>
      <xi-footer></xi-footer>
  </div>
</template>
<script>
  import axios from 'axios';
  import XiFooter from '../components/Footer.vue';
  import XiTop from '../components/Top.vue';
  export default {
    components: {
      axios,
      XiFooter,
      XiTop
    },
    data() {
      return {
            
      }
    },
    methods: {
    
    },
    computed: {
      IMG_HOST () {
        return this.$store.state.IMG_HOST;
      }
    },
    beforeMount() {
          
    }
  }
</script>
<style lang="sass" scoped>
    @import "../../sass/copyright/apply-waiting.scss";
    @import "../../sass/icons.scss";
</style>


// WEBPACK FOOTER //
// ApplyWaiting.vue?5edfda2c